<template>
  <b-card>
    <div>
      <div class="text-black text-[20px] mb-2 font-[600]">
        Partner Komchat
      </div>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-2">
      <GrowthCard
        title="User Registered"
        icon-card="https://storage.googleapis.com/komerce/assets/register-icon.svg"
        icon-bg-class="bg-[#EBF5FF]"
        :total="animatedCard.registered.total || 0"
        :percentage="dataCard.registered.percentage || `${animatedCard.registered.today || 0} Today`"
        :description="`User registered yesterday: ${dataCard.registered.yesterday || 0}`"
        :month.sync="monthRegistered"
        @month-change="handleMonthChange('registered')"
      />

      <GrowthCard
        title="User Verified"
        icon-card="https://storage.googleapis.com/komerce/assets/verified-icon.svg"
        icon-bg-class="bg-[#E6F8F0]"
        :total="animatedCard.verified.total || 0"
        :percentage="dataCard.verified.percentage || `${animatedCard.verified.today || 0} Today`"
        :description="`User verified yesterday: ${dataCard.verified.yesterday || 0}`"
        :month.sync="monthVerified"
        @month-change="handleMonthChange('verified')"
      />

      <GrowthCard
        title="User Active"
        icon-card="https://storage.googleapis.com/komerce/assets/register-icon.svg"
        icon-bg-class="bg-[#EBF5FF]"
        :total="animatedCard.active.now || 0"
        :percentage="dataCard.active.percentage || '0%'"
        :description="`User active last month: ${dataCard.active.last_month || 0}`"
        :month.sync="monthActive"
        @month-change="handleMonthChange('active')"
      />
    </div>
    <div>
      <TablePartner
        :items="itemsTable"
        :loading="isLoading"
        @handleSearchPartner="handleSearchPartner"
        @getNextData="getDataDashboard()"
        @handleFilter="handleTableFilter"
      />
    </div>
  </b-card>
</template>
<script>
import { IDRWithoutLbl } from '@/libs/currency'
import { firstDateOfMonth, lastDateOfMonth } from '@/store/helpers'
import { YEAR_MONTH_DAY, LABELMONTH } from '@/libs/filterDate'
import moment from 'moment'
import { optionsFilter } from '../config'
import TablePartner from '../components/TablePartner.vue'
import GrowthCard from '../components/GrowthCard.vue'

import {
  apiDahsboardKomchat, apiRegisteredGrowthKomchat, apiVerifiedGrowthKomchat, apiActivePartnerKomchat,
} from '../services/api.komchat.service'

export default {
  components: {
    TablePartner,
    GrowthCard,
  },
  data() {
    return {
      startDate: firstDateOfMonth,
      endDate: lastDateOfMonth,
      dataCard: {
        active: {
          now: 0,
          last_month: 0,
          percentage: '0%',
        },
        registered: {
          total: 0,
          today: 0,
          yesterday: 0,
        },
        verified: {
          total: 0,
          today: 0,
          yesterday: 0,
        },
      },
      // Animated counter values
      animatedCard: {
        active: {
          now: 0,
          last_month: 0,
        },
        registered: {
          total: 0,
          today: 0,
          yesterday: 0,
        },
        verified: {
          total: 0,
          today: 0,
          yesterday: 0,
        },
      },
      search: '',
      itemsTable: [],
      optionsFilter,
      limit: 15,
      offset: 0,
      filterRevenue: 'Bulan ini',
      filterRegistered: 'Bulan ini',
      filterVerified: 'Bulan ini',
      lastData: false,
      isLoading: false,
      IDRWithoutLbl,
      moment,
      monthlabel: LABELMONTH,
      monthRegistered: moment(),
      monthVerified: moment(),
      monthActive: moment(),
      filter: {
        status: [],
        typeProduct: [], // Changed to match TablePartner.vue's filter structure
      },
    }
  },
  async mounted() {
    await this.getDataDashboard()
    await this.getRegisteredGrowthCard()
    await this.getVerifiedGrowthCard()
    await this.getActivePartnerCard()
  },
  methods: {
    animateValue(obj, key, subKey, start, end, duration = 1000) {
      const startTimestamp = Date.now()
      const step = () => {
        const now = Date.now()
        const progress = Math.min((now - startTimestamp) / duration, 1)
        const easeOutQuart = 1 - (1 - progress) ** 4
        const current = Math.floor(start + (end - start) * easeOutQuart)

        if (subKey) {
          this.$set(obj[key], subKey, current)
        } else {
          this.$set(obj, key, current)
        }

        if (progress < 1) {
          requestAnimationFrame(step)
        } else if (subKey) {
          this.$set(obj[key], subKey, end)
        } else {
          this.$set(obj, key, end)
        }
      }
      requestAnimationFrame(step)
    },
    handleMonthChange(type) {
      let selectedMonth = null
      if (type === 'registered') selectedMonth = this.monthRegistered
      if (type === 'verified') selectedMonth = this.monthVerified
      if (type === 'active') selectedMonth = this.monthActive

      this.startDate = moment(selectedMonth).startOf('month').format('YYYY-MM-DD')
      this.endDate = moment(selectedMonth).endOf('month').format('YYYY-MM-DD')

      if (type === 'active') {
        this.getActivePartnerCard()
      } else if (type === 'registered') {
        this.getRegisteredGrowthCard()
      } else if (type === 'verified') {
        this.getVerifiedGrowthCard()
      }
    },
    handleFilterChange(value, type) {
      this.startDate = value.startDate
      this.endDate = value.endDate

      if (type === 'active') {
        this.getActivePartnerCard()
      } else if (type === 'registered') {
        this.getRegisteredGrowthCard()
      } else if (type === 'verified') {
        this.getVerifiedGrowthCard()
      }
    },
    handleDateFilterChange(dateRange, type) {
      this.startDate = dateRange.startDate
      this.endDate = dateRange.endDate

      if (type === 'active') {
        this.getActivePartnerCard()
      } else if (type === 'registered') {
        this.getRegisteredGrowthCard()
      } else if (type === 'verified') {
        this.getVerifiedGrowthCard()
      }
    },
    handleTableFilter(filters) {
      this.filter = filters
      this.itemsTable = []
      this.offset = 0
      this.lastData = false
      this.getDataDashboard()
    },
    handleSearchPartner: _.debounce(function searchData(value) {
      this.search = value
      this.lastData = false
      this.offset = 0
      this.itemsTable = []
      this.getDataDashboard()
    }, 1000),
    async getDataDashboard() {
      try {
        if (this.isLoading || this.lastData) return
        this.isLoading = true

        const { data } = await apiDahsboardKomchat({
          search: this.search,
          limit: this.limit,
          offset: this.offset + (this.itemsTable.length || 0),
          status: this.filter.status.join(','),
          productType: this.filter.typeProduct.join(','), // Updated to match new filter structure
        })

        // If no data returned at all, we've reached the end
        if (!data.data || data.data.length === 0) {
          this.lastData = true
          this.isLoading = false
          return
        }

        this.itemsTable = [...this.itemsTable, ...data.data]
        // this.offset += this.limit

        // Check if this is the last page (either by length or total count if available)
        if (data.total) {
          // If API provides total count
          this.lastData = this.itemsTable.length >= data.total
        } else {
          // If no total count, check if we received fewer items than requested
          this.lastData = data.data.length < this.limit
        }

        this.isLoading = false
      } catch (err) {
        this.$toast_error({ message: 'Gagal ambil data dashboard', err })
        this.isLoading = false
      }
    },
    async getActivePartnerCard() {
      try {
        const { data } = await apiActivePartnerKomchat({ start_date: YEAR_MONTH_DAY(this.startDate), end_date: YEAR_MONTH_DAY(this.endDate) })
        this.dataCard.active = data?.data

        // Animate active values
        this.animateValue(this.animatedCard.active, 'now', null, 0, data?.data?.now || 0, 1500)
        this.animateValue(this.animatedCard.active, 'last_month', null, 0, data?.data?.last_month || 0, 1500)
      } catch {
        this.$toast_error({ message: 'Gagal ambil data active partner' })
      }
    },
    async getRegisteredGrowthCard() {
      try {
        const { data } = await apiRegisteredGrowthKomchat({ start_date: YEAR_MONTH_DAY(this.startDate), end_date: YEAR_MONTH_DAY(this.endDate) })
        this.dataCard.registered = data?.data

        // Animate registered values
        this.animateValue(this.animatedCard.registered, 'total', null, 0, data?.data?.total || 0, 1500)
        this.animateValue(this.animatedCard.registered, 'today', null, 0, data?.data?.today || 0, 1500)
        this.animateValue(this.animatedCard.registered, 'yesterday', null, 0, data?.data?.yesterday || 0, 1500)
      } catch {
        this.$toast_error({ message: 'Gagal ambil data growth user' })
      }
    },
    async getVerifiedGrowthCard() {
      try {
        const { data } = await apiVerifiedGrowthKomchat({ start_date: YEAR_MONTH_DAY(this.startDate), end_date: YEAR_MONTH_DAY(this.endDate) })
        this.dataCard.verified = data?.data

        // Animate verified values
        this.animateValue(this.animatedCard.verified, 'total', null, 0, data?.data?.total || 0, 1500)
        this.animateValue(this.animatedCard.verified, 'today', null, 0, data?.data?.today || 0, 1500)
        this.animateValue(this.animatedCard.verified, 'yesterday', null, 0, data?.data?.yesterday || 0, 1500)
      } catch {
        this.$toast_error({ message: 'Gagal ambil data verified user' })
      }
    },
  },
}
</script>

<style>
.month-picker .month-year-display.input{
  width: 120px;
}
</style>
